var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error-alert"}},[_c('div',{staticClass:"main"},[_vm._v(_vm._s(_vm.value.msg))]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.value.info))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083cb1a9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop/ErrorAlert.vue
// module id = null
// module chunks = 